const updateFieldConditionPattern = {
  primaryState: null,
  states: [
    {
      field: '',
      state: 1,
      to: 0,
      targetField: '',
      value: ''
    }
  ],
  todo: [
    {
      action: 1,
      field: ''
    }
  ],
  all: 'true',
  name: 'New Update Condition'
}

const showHideFieldPattern = {
  primaryState: null,
  states: [
    {
      field: '',
      state: 1,
      to: 0,
      targetField: '',
      value: ''
    }
  ],
  todo: [
    {
      action: 1,
      field: ''
    }
  ],
  all: 'true',
  name: 'New Condition'
}


const toggleRequiredPattern = {
  name: 'New Condition',
  conditionType: 'toggleRequired',
  field: null,
  state: 'equalTo',
  value: '',
  targetField: null,
  action: null
}

const hideValuePattern = {
  field: '',
  value: '',
  action: '',
  name: 'New Hide Value'
}

const calcPattern = {
  questions: [
    {
      field: '',
      calculation: 6,
    }
  ],
  displayIn: '',
  name: 'New Calculation'
}

export {showHideFieldPattern, updateFieldConditionPattern, calcPattern, hideValuePattern, toggleRequiredPattern}



// WEBPACK FOOTER //
// ./src/utils/formBuilder/patterns.js